import {Component} from '@angular/core';
import {BentoAlertItemOptions} from '@bento/bento-ng';
import {BackendTokenClaims} from 'src/app/core/models/tokenResponse';
import {AuthService} from 'src/app/core/services/auth/auth.service';
import {Role} from 'src/app/shared/enums';
import {environment} from 'src/environments/environment';
import {ArrowNavigationService} from 'src/app/shared/arrow-navigation.service';
import {AxeToolCommonMethodsService} from 'src/app/core/services/axe-tool-common-methods/axe-tool-common-methods.service';
import {FeatureToggleService} from 'src/app/core/services/feature-toggle/feature-toggle.service';
declare let TRAAC: any;

@Component({
  selector: 'app-pmm-links',
  templateUrl: './pmm-links.component.html',
  styleUrls: ['./pmm-links.component.scss'],
})
export class PmmLinksComponent {
  alerts: BentoAlertItemOptions[] = [];
  isDataLoading = false;
  pmmVersion: string;
  isQuickSightEnabled = false;

  constructor(
    private authService: AuthService,
    private arrowNavigationService: ArrowNavigationService,
    private axeToolService: AxeToolCommonMethodsService,
    private featureToggleService: FeatureToggleService
  ) {
    this.pmmVersion = environment.pmmVersion;
  }
  async ngOnInit(): Promise<void> {
    await this.featureToggleService.getFeatureValue('QUICKSIGHT').then((val) => (this.isQuickSightEnabled = val));
    if (this.isQuickSightEnabled) {
      this.onTrackPMMTabClickEvent('link');
    }
  }
  ngAfterViewChecked() {
    this.axeToolService.removeAttributeToElement('.pmmTabsList', 'aria-selected');
    this.axeToolService.removeAttributeToElement('[wj-part="focus"]', 'tabindex');
  }

  public get isTAdmin(): boolean {
    const backendTokenClaims: BackendTokenClaims = this.authService.getBackendTokenClaims();
    return backendTokenClaims && backendTokenClaims.userDDO && backendTokenClaims.userDDO.role === Role.TAdmin;
  }

  public get isFAdmin(): boolean {
    const backendTokenClaims: BackendTokenClaims = this.authService.getBackendTokenClaims();
    return backendTokenClaims && backendTokenClaims.userDDO && backendTokenClaims.userDDO.role === Role.FAdmin;
  }

  launchPMM() {
    var downloadLink = document.createElement('a');
    downloadLink.href = environment.pmmUrl;
    downloadLink.download = environment.pmmFileName;
    downloadLink.target = '_blank';
    downloadLink.click();
  }
  onKeyDown(event: KeyboardEvent) {
    this.arrowNavigationService.handleKeyDown(event);
  }
  onTrackPMMTabClickEvent(name: string) {
    if (this.isQuickSightEnabled) {
      const backendTokenClaims: BackendTokenClaims = this.authService.getBackendTokenClaims();
      TRAAC.track(
        TRAAC.keyValue('PMM' + ' ' + name + ' ' + 'click', {
          firmId: backendTokenClaims.userDDO.firmID,
          userId: backendTokenClaims.userDDO.userID,
          eventName: 'PMM' + ' ' + name + ' ' + 'click',
          pmmVersion: this.pmmVersion,
        }).build()
      );
    }
  }
}
